import { Component, Input } from '@angular/core';
import {
  TangramMetrics,
  MyTangramRow,
  TangramPerfRow,
  TrendDelta
} from '../../models/analytics.types';
import { PAGE_SIZE } from '../../models/period-trends.const';

@Component({
  selector: 'tangram-pa-tangram-performance-tab',
  templateUrl: './tangram-performance-tab.component.html',
  styleUrls: ['./tangram-performance-tab.component.scss']
})
export class TangramPerformanceTabComponent {
  @Input() tangramMetrics: TangramMetrics = { views: 0, uniqueUsers: 0, completionRate: 0, avgTimeSpent: '0m' };
  @Input() myTangrams: MyTangramRow[] = [];
  @Input() topTangrams: TangramPerfRow[] = [];
  @Input() lowTangrams: TangramPerfRow[] = [];
  @Input() trends: { [key: string]: TrendDelta } = {};

  readonly PAGE_SIZE = PAGE_SIZE;
  myTangramPage = 1;

  trend(key: string): TrendDelta {
    return this.trends[key] || { delta: 0, unit: '' };
  }

  get pagedMyTangrams(): MyTangramRow[] {
    return this.myTangrams.slice(
      (this.myTangramPage - 1) * this.PAGE_SIZE,
      this.myTangramPage * this.PAGE_SIZE
    );
  }
}
